import React from "react";
export default function NotFound() {
  return <>Pagina inexistenta</>;
}
